import React, { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";

import SideNav from "../Layout/SideNav";
import Box from "@material-ui/core/Box";
import SearchBar from "material-ui-search-bar";
import Divider from "@material-ui/core/Divider";
import {
  createStyles,
  Theme,
  makeStyles,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem, { ListItemProps } from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import alertify from "alertifyjs";
import APIModel from "../../Models/APIModel";
import $ from "jquery";
import Loader from "react-loader-spinner";
import styled from "styled-components";
import { DialogContentText } from "@material-ui/core";
import { displayAlertifyError } from "../../util/functions";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: "25ch",
    },
    divider: {
      // Theme Color, or use css color in quote
      background: "#000",
    },
  })
);

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

function ListItemLink(props: ListItemProps<"a", { button?: true }>) {
  return <ListItem button component="a" {...props} />;
}

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

function Client() {
  const classes = useStyles();
  let get_token = localStorage.getItem("Token");
  let get_userid = localStorage.getItem("user_id");
  let user_status = localStorage.getItem("status");

  const [host, setHost] = useState(APIModel.HOST);
  const [token, setToken] = useState(get_token);
  const [userid, setUserId] = useState(get_userid);
  const [clients, setClients] = useState([]);

  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [other_mobile, setOtherMobile] = useState("");
  const [address, setAddress] = useState("");
  const [other_address, setOtherAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [postel_code, setPostelCode] = useState("");
  const [note, setNote] = useState("");
  const [delId, setDelId] = useState("");
  const [count, setCount] = useState(0);
  const [saveBtn, setSaveBtn] = useState(true);
  const [updateBtn, setUpdateBtn] = useState(false);
  const [selectedFile, setSelectedFile] = useState();

  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  const [search, setSearch] = useState("");
  const [foundClients, setFoundClients] = useState(clients);
  const [noResult, setNoResult] = useState(false);

  // dialog functions

  const filter = (event) => {
    console.log(event);
    setNoResult(true);
    const keyword = event;

    if (keyword !== "") {
      const results = clients.filter((client) => {
        return client.name.toLowerCase().startsWith(keyword.toLowerCase());
        // Use the toLowerCase() method to make it case-insensitive
      });
      setFoundClients(results);
    } else {
      setFoundClients(clients);
      // If the text field is empty, show all users
    }

    setSearch(keyword);
  };

  function allFilter() {
    setFoundClients(clients);
  }

  function handleClickOpen() {
    setOpen(true);
  }
  function handleClose() {
    setOpen(false);
  }

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  useEffect(async () => {
    setLoading(true);
    axios
      .get(host + "get-clients/" + userid, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        setClients(response.data.clients);
        setFoundClients(response.data.clients);
        setLoading(false);
      })
      .catch(function (error) {
        displayAlertifyError({
          error: "There is a problem in your network connection",
        });
      });
  }, [count]);

  function getData(id) {
    axios
      .get(host + "client-detail/" + id, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        setSaveBtn(false);
        setUpdateBtn(true);
        setId(response.data.client.id);
        setName(response.data.client.name);
        setEmail(response.data.client.email);
        setMobile(response.data.client.mobile);
        if (response.data.client.other_mobile == null) {
          setOtherMobile("");
        } else {
          setOtherMobile(response.data.client.other_mobile);
        }
        setAddress(response.data.client.address);
        if (response.data.client.address2 == null) {
          setOtherAddress("");
        } else {
          setOtherAddress(response.client.data.address2);
        }
        setCity(response.data.client.city);
        setState(response.data.client.state);
        setPostelCode(response.data.client.postel_code);
        if (response.data.client.note == null) {
          setNote("");
        } else {
          setNote(response.data.client.note);
        }
      })
      .catch(function (response) {
        if (response.status === false) {
          displayAlertifyError({ error: response.message });
        }
      });
  }

  function deleteClient(id) {
    axios
      .post(
        host + "client-delete",
        { id },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        alertify.success(response.data.message);
        setCount(count + 1);
      })
      .catch(function (error) {
        displayAlertifyError({ error: error });
      });
  }

  function newClient() {
    setSaveBtn(true);
    setUpdateBtn(false);
    setName("");
    setEmail("");
    setMobile("");
    setOtherMobile("");
    setAddress("");
    setOtherAddress("");
    setCity("");
    setState("");
    setPostelCode("");
    setNote("");
  }

  function createClient() {
    let nameVal = $("#name").val();
    setName(nameVal);
    let emailVal = $("#email").val();
    setEmail(emailVal);
    let mobileVal = $("#mobile").val();
    setMobile(mobileVal);
    let other_mobileVal = $("#other_mobile").val();
    setOtherMobile(other_mobileVal);
    let addressVal = $("#address").val();
    console.log(addressVal);
    setAddress(addressVal);
    let other_addressVal = $("#other_address").val();
    setOtherAddress(other_addressVal);
    let cityVal = $("#city").val();
    setCity(cityVal);
    let stateVal = $("#state").val();
    setState(stateVal);
    let postel_codeVal = $("#postel_code").val();
    setPostelCode(postel_codeVal);
    let noteVal = $("#note").val();
    setNote(noteVal);
    let params = {
      userid: userid,
      name: name,
      email: email,
      mobile: mobile,
      other_mobile: other_mobile,
      address: address,
      address2: other_address,
      city: city,
      state: state,
      postel_code: postel_code,
      note: note,
    };

    if (nameVal === "" || nameVal === undefined) {
      displayAlertifyError({ error: "Please enter name" });
      return false;
    }
    if (emailVal === "" || emailVal === undefined) {
      displayAlertifyError({ error: "Please enter email" });
      return false;
    }
    if (mobileVal === "" || mobileVal === undefined) {
      displayAlertifyError({ error: "Please enter mobile no" });
      return false;
    }
    if (addressVal === "" || addressVal === undefined) {
      displayAlertifyError({ error: "Please enter address" });
      return false;
    }
    if (cityVal === "" || cityVal === undefined) {
      displayAlertifyError({ error: "Please enter city" });
      return false;
    }
    if (stateVal === "" || stateVal === undefined) {
      displayAlertifyError({ error: "Please enter state" });
      return false;
    }
    if (postel_codeVal === "" || postel_codeVal === undefined) {
      displayAlertifyError({ error: "Please enter postel code" });
      return false;
    }

    return axios
      .post(host + "create-client", params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        alertify.success(response.data.message);
        setCount(count + 1);
        setName("");
        setEmail("");
        setMobile("");
        setOtherMobile("");
        setAddress("");
        setOtherAddress("");
        setCity("");
        setState("");
        setPostelCode("");
        setNote("");
      })
      .catch((response) => {
        console.log(response);
      });
  }

  function updateClient() {
    let nameVal = $("#name").val();
    setName(nameVal);
    let emailVal = $("#email").val();
    setEmail(emailVal);
    let mobileVal = $("#mobile").val();
    setMobile(mobileVal);
    let other_mobileVal = $("#other_mobile").val();
    setOtherMobile(other_mobileVal);
    let addressVal = $("#address").val();
    setAddress(addressVal);
    let other_addressVal = $("#other_address").val();
    setOtherAddress(other_addressVal);
    let cityVal = $("#city").val();
    setCity(cityVal);
    let stateVal = $("#state").val();
    setState(stateVal);
    let postel_codeVal = $("#postel_code").val();
    setPostelCode(postel_codeVal);
    let noteVal = $("#note").val();
    setNote(noteVal);
    let params = {
      id: id,
      name: name,
      email: email,
      mobile: mobile,
      other_mobile: other_mobile,
      address: address,
      address2: other_address,
      city: city,
      state: state,
      postel_code: postel_code,
      note: note,
    };

    if (nameVal === "" || nameVal === undefined) {
      displayAlertifyError({ error: "Please enter name" });
      return false;
    }
    if (emailVal === "" || emailVal === undefined) {
      displayAlertifyError({ error: "Please enter email" });
      return false;
    }
    if (mobileVal === "" || mobileVal === undefined) {
      displayAlertifyError({ error: "Please enter mobile no" });
      return false;
    }
    if (addressVal === "" || addressVal === undefined) {
      displayAlertifyError({ error: "Please enter address" });
      return false;
    }
    if (cityVal === "" || cityVal === undefined) {
      displayAlertifyError({ error: "Please enter city" });
      return false;
    }
    if (stateVal === "" || stateVal === undefined) {
      displayAlertifyError({ error: "Please enter state" });
      return false;
    }
    if (postel_codeVal === "" || postel_codeVal === undefined) {
      displayAlertifyError({ error: "Please enter postel code" });
      return false;
    }

    return axios
      .post(host + "client-edit", params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        alertify.success(response.data.message);
        setCount(count + 1);
      })
      .catch((response) => {
        console.log(response);
      });
  }

  function exportClient() {
    axios
      .get(host + "export-client/" + userid, {
        headers: {
          "Content-Type": "application/excel",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "clients.csv"); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  function sampleClient() {
    axios
      .get(host + "download-sample-client/", {
        headers: {
          "Content-Type": "application/excel",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "sample-clients.csv"); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  function importClient() {
    const fd = new FormData();
    if (selectedFile === "" || selectedFile === undefined) {
      displayAlertifyError({ error: "Please select excel file first." });
      return false;
    } else {
      fd.append("file", selectedFile, selectedFile.name);
    }
    return axios
      .post(host + "import-client/" + userid, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        setOpen(false);
        alertify.success(response.data.message);
        setCount(count + 1);
      })
      .catch((response) => {
        console.log(response);
      });
  }

  if (token) {
    if (user_status === "user") {
      return <Redirect to="/payment"></Redirect>;
    } else {
      return (
        <div className="wrapper">
          <SideNav />
          <div className="main-panel">
            <div className="content">
              <div className="container-fluid">
                <div className="row">
                  <Dialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={open}
                  >
                    <DialogTitle
                      id="customized-dialog-title"
                      onClose={handleClose}
                    >
                      Clients
                    </DialogTitle>
                    <DialogContent dividers>
                      <Link onClick={() => sampleClient()}>
                        <h3>1. Download Sample File</h3>
                      </Link>
                      <h3>2. Fill out the information you want to import.</h3>
                      <form enctype="multipart/form-data">
                        <input
                          type="file"
                          name="file"
                          onChange={changeHandler}
                        />
                      </form>
                    </DialogContent>
                    <DialogActions>
                      <Button autoFocus onClick={importClient} color="primary">
                        Import Data
                      </Button>
                    </DialogActions>
                  </Dialog>

                  <div className="col-12 col-lg-4">
                    <div className="row pl-3">
                      <FormControl className="col-12 col-md-6">
                        <InputLabel id="demo-simple-select-label">
                          Import/Export
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="import-export"
                          name="import-export"
                        >
                          <MenuItem
                            value={1}
                            onClick={() => {
                              handleClickOpen();
                            }}
                          >
                            Import
                          </MenuItem>
                          <MenuItem
                            value={2}
                            onClick={() => {
                              exportClient();
                            }}
                          >
                            Export
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <div className="col-12 col-md-6 text-md-right pl-0 pl-md-3 pt-3 pt-md-0">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => newClient()}
                        >
                          New Client
                        </button>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <div className="card">
                          <SearchBar
                            placeholder="Search"
                            value={search}
                            onChange={filter}
                            onCancelSearch={allFilter}
                          />
                          <div
                            className="card-body mt-2"
                            style={{
                              maxHeight: 478,
                              minHeight: 450,
                              overflow: "auto",
                            }}
                          >
                            <div className={classes.root}>
                              {!loading ? (
                                foundClients && foundClients.length > 0 ? (
                                  foundClients.map((item) => (
                                    <List
                                      component="nav"
                                      aria-label="secondary mailbox folders"
                                    >
                                      <ListItem
                                        button
                                        key={item.id}
                                        id={item.id}
                                        onClick={() => getData(item.id)}
                                      >
                                        <ListItemText
                                          style={{ color: "#FC3538" }}
                                          primary={item.name}
                                        />
                                      </ListItem>
                                      <ListItemSecondaryAction>
                                        {/* <IconButton edge="end" aria-label="delete" onClick={() => deleteClient(item.id)}>
                                                          <DeleteIcon color="error" />
                                                          </IconButton> */}
                                      </ListItemSecondaryAction>
                                      <Divider />
                                    </List>
                                  ))
                                ) : noResult ? (
                                  <h4>No results found!</h4>
                                ) : (
                                  <h1></h1>
                                )
                              ) : (
                                <DivLoader>
                                  <Loader
                                    type="Oval"
                                    color="#FC3538"
                                    height={50}
                                    width={50}
                                  />
                                </DivLoader>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-lg-8">
                    <div className="row">
                      <div className="col-12 d-flex justify-content-md-end">
                        {updateBtn ? (
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                              updateClient();
                            }}
                          >
                            Update
                          </button>
                        ) : null}
                        {saveBtn ? (
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                              createClient();
                            }}
                          >
                            Save
                          </button>
                        ) : null}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <div className="card">
                          <div className="card-body">
                            <form id="create_client">
                              <div
                                className="row"
                                style={{
                                  maxHeight: 450,
                                  minHeight: 450,
                                  overflow: "auto",
                                }}
                              >
                                <Box
                                  fontSize={20}
                                  fontWeight="fontWeightRegular"
                                  ml={2}
                                  mb={2}
                                >
                                  Basic Information
                                </Box>
                                <div className="col-12">
                                  <div className="form-group mb-1">
                                    <label className="mdc-floating-label--shake">
                                      Name
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      id="name"
                                      name="name"
                                      required="required"
                                      autoFocus
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="form-group mb-1">
                                    <label className="mdc-floating-label--shake">
                                      Email
                                    </label>
                                    <input
                                      type="email"
                                      className="form-control input-box"
                                      id="email"
                                      name="email"
                                      required="required"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="form-group mb-1">
                                    <label className="mdc-floating-label--shake">
                                      Phone (mobile)
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      id="mobile"
                                      name="mobile"
                                      required
                                      value={mobile}
                                      onChange={(e) =>
                                        setMobile(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="form-group mb-1">
                                    <label className="mdc-floating-label--shake">
                                      Phone (other)
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      id="other_mobile"
                                      name="other_mobile"
                                      required
                                      value={other_mobile}
                                      onChange={(e) =>
                                        setOtherMobile(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                                <Box
                                  fontSize={20}
                                  fontWeight="fontWeightRegular"
                                  mt={2}
                                  ml={2}
                                  mb={2}
                                >
                                  Billing Address
                                </Box>
                                <div className="col-12">
                                  <div className="form-group mb-1">
                                    <label className="mdc-floating-label--shake">
                                      Address
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      id="address"
                                      name="address"
                                      required
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="form-group mb-1">
                                    <label className="mdc-floating-label--shake">
                                      Address 2
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      id="other_address"
                                      name="other_address"
                                      required
                                      value={other_address}
                                      onChange={(e) =>
                                        setOtherAddress(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="form-group mb-1">
                                    <label className="mdc-floating-label--shake">
                                      City
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      id="city"
                                      name="city"
                                      required
                                      value={city}
                                      onChange={(e) => setCity(e.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="form-group mb-1">
                                    <label className="mdc-floating-label--shake">
                                      State
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      id="state"
                                      name="state"
                                      required
                                      value={state}
                                      onChange={(e) => setState(e.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="form-group mb-1">
                                    <label className="mdc-floating-label--shake">
                                      Postal Code
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      id="postel_code"
                                      name="postel_code"
                                      required
                                      value={postel_code}
                                      onChange={(e) =>
                                        setPostelCode(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="form-group mb-1">
                                    <label className="mdc-floating-label--shake">
                                      Note
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      id="note"
                                      name="note"
                                      required
                                      value={note}
                                      onChange={(e) => setNote(e.target.value)}
                                    />
                                  </div>
                                </div>
                              </div>
                              <Link
                                to="/invoices/new"
                                className="btn btn-primary pull-right mr-2"
                              >
                                New Invoice
                              </Link>
                              <Link
                                to="/estimates/new"
                                className="btn btn-primary pull-right mr-2"
                              >
                                New Estimate
                              </Link>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  } else {
    return <Redirect to="/"></Redirect>;
  }
}

export default Client;

const DivLoader = styled.div`
  text-align: center;
  margin: 30px 0px;
`;

const DeleteClientDialog = ({ open, closeDialog, deleteClient, deleteID }) => {
  return (
    <DivDeleteDialog>
      <Dialog
        open={open}
        onClose={closeDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Delete Client Alert"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete the Client ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            variant="outlined"
            size="small"
            onClick={closeDialog}
          >
            No
          </Button>
          <Button
            color="primary"
            variant="contained"
            size="small"
            onClick={() => deleteClient(deleteID)}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </DivDeleteDialog>
  );
};

const DivDeleteDialog = styled.div``;
